/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CoursefinancialCoursefinancialidClassesId200,
  GetApiV1CoursefinancialCoursefinancialidClassesId401,
  GetApiV1CoursefinancialCoursefinancialidClassesId404,
  GetApiV1CoursefinancialCoursefinancialidClassesId500,
  GetApiV1CoursefinancialCoursefinancialidClassesIdPathParams,
  GetApiV1CoursefinancialCoursefinancialidClassesIdQueryResponse,
} from "../../types/courseFinancialClassesController/GetApiV1CoursefinancialCoursefinancialidClassesId.ts";
import { courseFinancialClassStudentViewModelSchema } from "../courseFinancialClassStudentViewModelSchema.ts";

export const getApiV1CoursefinancialCoursefinancialidClassesIdPathParamsSchema =
  z.object({
    courseFinancialId: z.coerce.number().int(),
    id: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidClassesIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CoursefinancialCoursefinancialidClassesId200Schema =
  z.lazy(
    () => courseFinancialClassStudentViewModelSchema,
  ) as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidClassesId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CoursefinancialCoursefinancialidClassesId401Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidClassesId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CoursefinancialCoursefinancialidClassesId404Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidClassesId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CoursefinancialCoursefinancialidClassesId500Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidClassesId500>;

export const getApiV1CoursefinancialCoursefinancialidClassesIdQueryResponseSchema =
  z.lazy(
    () => getApiV1CoursefinancialCoursefinancialidClassesId200Schema,
  ) as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidClassesIdQueryResponse>;
